
define(
	'Code25.CaterpartsGlobal.Addressio.View'
	, [
		"Handlebars", "Utils", "Code25.addressio.tpl", "Tools", "Profile.Model"
	]
	, function (
		Handlebars, Utils, Code25_addressio_tpl, Tools, ProfileModel
	) {
		'use strict';

		return Backbone.View.extend({
			loading: "",
			key: "dtoken_hEDzcyiWMr1EHQG8j5sCw72cCdy030acjSuVgX8OAm0aFHIU3VajX41eyhADhPZynvKrSYEvJvn0qGUWdO-Wxfg82rxGorBrGBTfADrf7wNL7L8_MeEyCcqtn_HwAcnOqALOQhN0qer7Ao60jiU-xXSYntRzMiWXAQoUmq2H0lwMHUOmvkrP7GRF7vK8Y7jZ61F5v4qlyJ8",
			lastTerm: "",
			template: Code25_addressio_tpl,
			initialize: function (options) {

			},

			events: {
				'keyup [data-action="search"]': 'onKeyUp',
				'click [data-action="address"]': 'onAddress'

			},
			onAddress: function (e) {

				var id = e.target.getAttribute("data-id");
				var self = this;

				$.getJSON("https://api.getAddress.io/get/" + id + "?api-key=" + this.key, function (res) {
					//console.log("success", res);

					if (res.country == "England" || res.country == "Scotland" || res.country == "Wales" || res.country == "Northern Ireland") {
						res.country = "United Kingdom";
					}
					if(res.town_or_city=="London"){
						res.town_or_city=res.district||res.town_or_city;
						res.county="Greater London";
					}
					var profile = ProfileModel.getInstance();
					if (!res.building_name) {
						res.building_name = profile.get("companyname") || "";
					}
					if (!res.residential) {
						
						res.building_name=res.line_1;
						res.line_1=res.line_2;
						res.line_2=res.line_3||res.line_4||"";
					}
					res.name = profile.get("name") || "";
					this.lastTerm = "";
					self.render();
					var el, names = { zip: "postcode", city: "town_or_city", company: "building_name", state: "county", country: "country", addr1: "line_1", addr2: "line_2", fullname: "name" }, innerText;
					for (var i in names) {
						el = $.find("[name='" + i + "']");
						if (el.length > 0) {
	
							if (el[0].tagName.toLowerCase() == "select") {
	
								for (var child in el[0].children) {
									innerText = child.innerText ? child.innerText.trim() : "";
	
									if (child.getAttribute("value") == res[names[i]] || innerText == res[names[i]]) {
	
										child.setAttribute("selected", "selected");
										break;
									}
								}
							} else {
								el[0].value = res[names[i]] || "";
							}
	
						}
					}
					if (res.residential) {
	
						$.find("[name='isresidential']")[0].setAttribute("checked", true);
					}

				})
					.fail(function () {
						console.log("error");
					});

			},
			onKeyUp: function (e) {
				var term = e.target.value;
				if (term != this.lastTerm) {
					this.lastTerm = term;


					// var test = {
					// 	"suggestions": [
					// 		{
					// 			"address": "35 Wharfside Apartments, Prospect Terrace, Bury, Lancashire",
					// 			"url": "/get/YWYzMmZkZWIwM2NhZjdlIDI3NjM4ODY1IDMwZTU3OWYzZjQ1OTBiNA==",
					// 			"id": "YWYzMmZkZWIwM2NhZjdlIDI3NjM4ODY1IDMwZTU3OWYzZjQ1OTBiNA=="
					// 		},
					// 		{
					// 			"address": "35 Wharfside, Prospect Terrace, Bury, Lancashire",
					// 			"url": "/get/Yjk1NDk5NGU2YzQ3ZjJkIDMxMjkwNDcyNiAzMGU1NzlmM2Y0NTkwYjQ=",
					// 			"id": "Yjk1NDk5NGU2YzQ3ZjJkIDMxMjkwNDcyNiAzMGU1NzlmM2Y0NTkwYjQ="
					// 		},
					// 		{
					// 			"address": "Phones 4 U, 35 Central Street, Bury, Lancashire",
					// 			"url": "/get/MTMzNTM0Y2NiZjU4ZjNkIDE1MTgzNjg1IDMwZTU3OWYzZjQ1OTBiNA==",
					// 			"id": "MTMzNTM0Y2NiZjU4ZjNkIDE1MTgzNjg1IDMwZTU3OWYzZjQ1OTBiNA=="
					// 		},
					// 		{
					// 			"address": "35 Premier Way, Bury, Lancashire",
					// 			"url": "/get/M2ZiMTFiMzEwMTkxOGM0IDI0MjQ1Mjk3NDQgMzBlNTc5ZjNmNDU5MGI0",
					// 			"id": "M2ZiMTFiMzEwMTkxOGM0IDI0MjQ1Mjk3NDQgMzBlNTc5ZjNmNDU5MGI0"
					// 		},
					// 		{
					// 			"address": "Pembrooke Law Ltd, 35 Knowsley Street, Bury, Lancashire",
					// 			"url": "/get/NWVjYTI5N2QzYzA0NDczIDQwNjA0NTA4OCAzMGU1NzlmM2Y0NTkwYjQ=",
					// 			"id": "NWVjYTI5N2QzYzA0NDczIDQwNjA0NTA4OCAzMGU1NzlmM2Y0NTkwYjQ="
					// 		},
					// 		{
					// 			"address": "35 Peers Street, Bury, Lancashire",
					// 			"url": "/get/MTg2MTMwMTdmYTk4MTdhIDE1MTMyMTExIDMwZTU3OWYzZjQ1OTBiNA==",
					// 			"id": "MTg2MTMwMTdmYTk4MTdhIDE1MTMyMTExIDMwZTU3OWYzZjQ1OTBiNA=="
					// 		}
					// 	]
					// };

					this.loadSuggestions(term);
				}

			}, loadSuggestions: function (term) {
				if (this.loading) {
					this.loading = term;
				} else {
					this.loading = term;
					var self = this;
					$.getJSON("https://api.getAddress.io/autocomplete/" + term + "?api-key=" + this.key, function (res) {
						var suggestions = [];
						if (res && res.suggestions) {
							suggestions = res.suggestions;
						}

						self.showSuggestions(suggestions);
						if (self.loading != term) {
							term = self.loading;
							self.loading = "";
							self.loadSuggestions(term);
						} else {
							self.loading = "";
						}
					})
						.fail(function (err) {
							console.log("error", err);
							self.loading = "";
						});
				}
			}
			,
			showSuggestions: function (suggestions) {

				if (JSON.stringify(suggestions != JSON.stringify(this.suggestions))) {
					
					var sel = this.$el.find("[name='suggestions']")[0];

					this.suggestions = suggestions;
					if (suggestions.length == 0) {
						sel.innerHTML = "";
					} else {
						var body = "";
						body += "<div class=\"addressio-list\">";
						for (var i = 0; i < suggestions.length; i++) {
							body += "<div class=\"addressio-listitem\" data-action=\"address\" data-id=\"" + suggestions[i].id + "\" data-url=\"" + suggestions[i].url + "\">" + suggestions[i].address + "</div>";
						}
						body += "</div>";
						sel.innerHTML = body;
					}
				}

			},
			getContext: function getContext() {

				return {
					suggestions: this.lastTerm ? this.suggestions || [] : []
				};
			}
		});

	});



